module.exports = __webpack_public_path__ + "49d7e16e61bb6c33bff72c9a63001590.svg";